import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appFormatTaxId]',
  standalone: false
})
export class FormatTaxIdDirective {
  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event'])
  onInputChange(event: Event): void {
    const input = this.el.nativeElement as HTMLInputElement;

    // Allow only alphanumeric (A-Z, 0-9)
    let value = input.value.replace(/[^0-9a-zA-Z]/g, '');

    // Insert hyphen after 3rd character if length > 3
    if (value.length > 2) {
      value = value.substring(0, 2) + '-' + value.substring(2);
    }

    // Optional: limit total length (example: 12 including hyphen)
    if (value.length > 10) {
      value = value.substring(0, 10);
    }

    input.value = value.toUpperCase();
  }
}
